import clienteAxios from "../config/axios";

export async function getBloqueadosReserva() {
    return clienteAxios.get('/bloqueadoReserva');
}

export async function addBloqueadoReserva(bloqueado) {
    return clienteAxios.post('/bloqueadoReserva', { bloqueado });
}

export async function updateBloqueadoReserva(id, updates) {
    return clienteAxios.put('/bloqueadoReserva', { id, updates });
}

export async function deleteBloqueadoReserva(id) {
    return clienteAxios.delete('/bloqueadoReserva', { data: { id } });
}

export async function deleteAllBloqueadosReserva() {
    return clienteAxios.delete('/bloqueadoReserva/deleteAll');
}
